import * as React from "react";
import { MediaQuery, Button } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import { formatPrice } from "@grandvisionhq/utils";
import { usePaymentMethodLabelsMap } from "../../../../hooks/hooks/use-payment-method-labels-map.js";
/* empty css                 */
import { PaymentMethod, PaymentServiceProvider } from "../../../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
import { AdyenPaypalActionButton } from "../../../../modules/ExpressPaymentMethods/Paypal/AdyenPaypalActionButton/modules/ExpressPaymentMethods/Paypal/AdyenPaypalActionButton/AdyenPaypalActionButton.js";
import { PaypalActionButtonContainer } from "../../../../modules/ExpressPaymentMethods/Paypal/PaypalActionButton/modules/ExpressPaymentMethods/Paypal/PaypalActionButton/PaypalActionButtonContainer.js";
import { ApplePayButton } from "../../../../modules/ExpressPaymentMethods/ApplePay/modules/ExpressPaymentMethods/ApplePay/ApplePayButton.js";
import { DonationFormComponent } from "../../../DonationFormComponent/component/DonationFormComponent/DonationFormComponent.js";
import { usePaymentsUIContext } from "../../../../context/PaymentsUI/context/PaymentsUI/context.js";
const PaymentForm = ({
  paymentMethod,
  paymentProvider,
  form,
  onHandlePaymentAction,
  donations,
  selectedDonation,
  onDonationSelected,
  totalPrice
}) => {
  const { getLabel, hasLabel, locale, currency } = useIntl();
  const { actionLabels } = usePaymentMethodLabelsMap();
  const breakPoint = MediaQuery.useBreakpoint();
  const { isProcessingOrder, currentCardBrand } = usePaymentsUIContext();
  const [enableWaitText, setEnableWaitText] = React.useState(false);
  React.useEffect(() => {
    if (isProcessingOrder) {
      const timeoutId = setTimeout(() => {
        setEnableWaitText(true);
      }, 3e3);
      return () => clearTimeout(timeoutId);
    } else {
      setEnableWaitText(false);
    }
  }, [isProcessingOrder]);
  const actionButton = React.useMemo(() => {
    switch (paymentMethod) {
      case PaymentMethod.APPLE_PAY:
        return /* @__PURE__ */ React.createElement(
          ApplePayButton,
          {
            type: "regular-checkout",
            onClick: onHandlePaymentAction,
            isDisabled: isProcessingOrder
          }
        );
      case PaymentMethod.PAYPAL:
        return paymentProvider === PaymentServiceProvider.ADYEN ? /* @__PURE__ */ React.createElement(AdyenPaypalActionButton, { onClick: onHandlePaymentAction, isDisabled: isProcessingOrder }) : /* @__PURE__ */ React.createElement(PaypalActionButtonContainer, { isDisabled: isProcessingOrder });
      case PaymentMethod.GOOGLE_PAY:
        return null;
      default:
        return /* @__PURE__ */ React.createElement(
          Button,
          {
            color: "primary",
            size: breakPoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE ? "small" : void 0,
            caption: `${getLabel(`checkout.action.pay.continueWith`)} ${actionLabels[paymentMethod]} (${formatPrice({
              locale,
              value: (totalPrice ?? 0) + (selectedDonation ?? 0),
              currency,
              isCentAmount: true
            })})`,
            "data-t": `button-next-payment`,
            disabled: isProcessingOrder,
            onClick: onHandlePaymentAction,
            isLoading: isProcessingOrder
          }
        );
    }
  }, [
    paymentMethod,
    onHandlePaymentAction,
    isProcessingOrder,
    paymentProvider,
    breakPoint,
    getLabel,
    actionLabels,
    locale,
    totalPrice,
    selectedDonation,
    currency
  ]);
  const handleDonationSelected = React.useCallback(
    (foundationKey, amount) => {
      onDonationSelected && onDonationSelected({ paymentMethod, foundationKey, amount });
    },
    [onDonationSelected, paymentMethod]
  );
  return /* @__PURE__ */ React.createElement("div", { className: "payment-form-container" }, /* @__PURE__ */ React.createElement("div", { className: "payment-form-container__form" }, form && form), actionButton, hasLabel(`checkout.${paymentMethod?.toLowerCase()}.instruction`) && /* @__PURE__ */ React.createElement(Text, { className: "payment-form-container__instruction" }, getLabel(`checkout.${paymentMethod?.toLowerCase()}.instruction`)), enableWaitText && /* @__PURE__ */ React.createElement(Text, { className: "payment-form-container__instruction" }, getLabel(`checkout.payment.wait.instruction`)), donations?.map((donation, index) => /* @__PURE__ */ React.createElement(
    DonationFormComponent,
    {
      foundationKey: donation.key,
      key: index,
      name: `${paymentMethod?.toLowerCase()}-donations`,
      options: donation.options,
      onClick: handleDonationSelected,
      ...currentCardBrand && donation?.brands && {
        isBrandNotSupportedForDonation: !donation.brands.includes(currentCardBrand)
      },
      ...selectedDonation && { initialValue: selectedDonation }
    }
  )));
};
export {
  PaymentForm
};
//# sourceMappingURL=PaymentForm.js.map
